import React, { useEffect, useState } from 'react';
import { useQrGenerator } from '../../utils/customHooks.js';

export const useFetchQrImage = (route, qrStyle) => {
    const qrCode = useQrGenerator({ route: route, qrStyle: qrStyle });
    const [ qrImage, setQRImage ] = useState(null);
    
    useEffect(() => {
        let isMounted = true;
        
        const handleQrCode = async () => {
            setQRImage(null);
            const blob = await qrCode.getRawData('png');
            if (!isMounted) return;
            isMounted && setQRImage(URL.createObjectURL(blob));
        };

        if (qrCode) handleQrCode();

        return () => {
            isMounted = false;
        };
    },[qrStyle, qrCode, setQRImage]);

    return qrImage;
};